import Vue from 'vue'
import Vuex from 'vuex'
import manufactures from './manufactures'
import users from './users'
import orders from './orders'
import routeTasks from './route-tasks'
import couriers from './couriers'
import pageLoader from './page-loader'
import serverErrors from './server-errors'
import sharedTime from './shared-time'
import notifications from './notifications'
import system from './system'
import mapLoading from './map-loading'
import encashment from './encashment'
import shiftReport from './shift-report'
import sharedData from './shared-data'
import regionOrders from './region-orders'
import dashboardManufactures from './dashboard-manufactures'
import productionSummary from './production-summary'
import collectOrders from './collect-orders'
import logistics from './logistics-features'
import globalSettings from './global-settings'

Vue.use(Vuex)

export default new Vuex.Store({
  namespaced: true,
  state: {
    notUserSelect: false,
    modalsCount: 0
  },
  mutations: {
    SET_NOT_USER_SELECT(state, notUserSelect) {
      state.notUserSelect = notUserSelect
    },
    SET_MODALS_COUNT(state, modalsCount) {
      state.modalsCount = modalsCount
    }
  },
  modules: {
    manufactures,
    users,
    orders,
    routeTasks,
    couriers,
    pageLoader,
    serverErrors,
    sharedTime,
    notifications,
    system,
    mapLoading,
    encashment,
    shiftReport,
    sharedData,
    regionOrders,
    dashboardManufactures,
    productionSummary,
    collectOrders,
    logistics,
    globalSettings
  }
})
